module.exports = __webpack_public_path__ + "lpg-masaze_1_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/ostatni/lpg-masaze_1_after.jpg
// module id = 1047
// module chunks = 0